import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-heading2',
  templateUrl: './heading2.component.html',
  styleUrls: ['./heading2.component.scss']
})
export class Heading2Component implements OnInit {
  @Input() text: string = ''
  @Input() isTextBlack: boolean = true
  constructor() { }

  ngOnInit(): void {
  }

}
